import {
    DateShowtimePickerConfig,
    FilmThumbnailMediaType,
    ShowtimePickerEvents,
} from '@vista/omnichannel-components-ui'
import { DateShowtimePickerPropsType, DateShowtimePickerPropsWithFilmIdsPropsType } from '../../types'
import {
    DateShowtimePickerPropsWithFilmIds,
    defaultDateShowtimePickerPropsWithFilmIds,
} from '@vista/omnichannel-components-ui/lib/src/lib/components/date-showtime-picker/types/props'
import { Film, Showtime } from '@vista-digital/ocapi-types/v1'
import { isSignedIn, MovioTracker, UrlFactory } from '../../utils'

import { DateShowtimePickerSelectedBusinessDate } from '@vista/omnichannel-components-ui'

export function dateShowtimePickerProps(props: DateShowtimePickerPropsType): DateShowtimePickerPropsWithFilmIds {
    const siteIds = props?.workflow?.entityIds?.siteId ? [props.workflow.entityIds.siteId] : undefined

    const filmIds = props?.workflow?.entityIds?.filmId ? [props.workflow.entityIds.filmId] : undefined

    const selectedBusinessDate: DateShowtimePickerSelectedBusinessDate = props?.workflow?.entityIds?.screeningDate
        ? DateShowtimePickerSelectedBusinessDate[props.workflow.entityIds.screeningDate]
        : undefined

    const assets = {
        ...defaultDateShowtimePickerPropsWithFilmIds.assets,
        noSitesSelectedIconName: 'no-site-selected',
        noShowtimesIconName: 'film-strip',
        failedToLoadDataIconName: 'curzon-warning',
    }

    const config = dateShowtimePickerConfig(props, selectedBusinessDate)

    if (!siteIds) {
        /*@ts-ignore*/
        delete config.allFilmsToggle
    }

    return {
        siteIds,
        filmIds,
        displayText: props.displayText,
        assets,
        config,
        events: showtimePickerEvents(props),
        cdnOptions: {
            censorRatingIcon: { height: 60 },
            filmThumbnailImage: { width: 500 },
            attributeIcon: { height: 40 },
            heroAttributeIcon: { height: 64 },
            promotedAttributeIcon: { height: 32 },
        },
    }
}

function dateShowtimePickerConfig(
    props: DateShowtimePickerPropsType,
    selectedBusinessDate: DateShowtimePickerSelectedBusinessDate
): DateShowtimePickerConfig {
    const url = new UrlFactory(props.workflow)

    let config: DateShowtimePickerConfig = {
        ...props.config,
        filmDetails: {
            show: (props.config as any).showFilmDetails,
            mediaType: FilmThumbnailMediaType.Still,
        },
        playTrailerButton: {
            show: true,
            showControls: true,
            autoPlay: true,
            muted: true,
            loop: true,
        },
        datePicker: {
            ...props.config.datePicker,
        },
        showtimeUrlFactory: (showtime: Showtime) => url.getSeatPickerDetailsUrl(showtime.id),
        filmUrlFactory: (film: Film) => url.getFilmDetailsUrl(film),
    }

    /*@ts-ignore*/
    delete config.showFilmDetails

    if (selectedBusinessDate) {
        config.datePicker.selectedBusinessDate = selectedBusinessDate
    }

    return config
}

function showtimePickerEvents(props: DateShowtimePickerPropsType): ShowtimePickerEvents {
    const movioTracker = new MovioTracker()
    const url = new UrlFactory(props.workflow)
    const onFilmActionLinkClicked = props.config.filmActionLink?.show
        ? (film: Film) => window.location.assign(url.getFilmDetailsUrl(film))
        : undefined

    const onShowtimeClicked = (showtime: Showtime) => {
        const index: number = showtime.isAllocatedSeating || !isSignedIn() ? 0 : 1
        return window.location.assign(url.getSeatPickerDetailsUrl(showtime.id, index))
    }

    const onPlayTrailerButtonClicked = (film: Film) => movioTracker.movieTrailer(film.id)

    return { onFilmActionLinkClicked, onShowtimeClicked, onPlayTrailerButtonClicked }
}
